import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c293243"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import {inject} from "vue";
    import FileStore, { key } from './FileManager';
    import { circuitConfigInjectionKey, defaultCircuits } from "./CircuitSelector/CircuitManager";
    import { toastInjectionKey } from "./Toaster/ToastManager";
    import { fit } from "./Fitting";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FittingExecutant',
  setup(__props) {

    const files = inject(key);
    const toaster = inject(toastInjectionKey);
    const circuits = inject(circuitConfigInjectionKey, defaultCircuits);

    const fitting = function(){
        const circuit = circuits.circuits.find(circuit=>circuit.selected);
        if(!circuit){return;}
        if(!files){return;}

        FileStore.keys().filter(key=>files.files[key].status === "OK").forEach(key=>{
            if(files.files[key].fitting_result.isDone){
                return;
            }

            toaster?.info(`${files.files[key].file.name}`, "Fitting Started", 2000);
            files.files[key].under_fitting = true;

            fit(files.files[key], circuit).then((result:any)=>{
                toaster?.success(`${files.files[key].file.name}\nFit: ${result.fit}`, "Fitting Complete", 2000);
            }).catch(()=>{
                toaster?.alert(`${files.files[key].file.name}`, "Fitting Failed", 2000);
            }).finally(()=>{
                files.files[key].under_fitting = false;
            });
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: !(_unref(files) && _unref(files).size() > 0),
    onClick: fitting
  }, "FITTING", 8, _hoisted_1))
}
}

})